import { Message } from 'view-design'
import axios from 'axios'
import { merge as _merge} from 'lodash'
import qs from 'qs'
import { defaultConfig } from '../config/axios'

export const ERR_TEXT = "出了点问题，请稍后重试"

// 拦截器
export const axiosInterceptor = function() {
  axios.interceptors.request.use(function(config) {
    return Object.assign({}, config, {
      transformRequest: [
        function(data) {
          data = qs.stringify(data)
          return data
        }
      ]
    })
  })
  axios.interceptors.response.use(
    response => {
      const res = response.data
      Message.destroy()
      if (!res) {
        setTimeout(() => {
          Message.error('出了点问题，请稍后重试')
        }, 10)
        return
      }
      if (res.stat == -1) {
        // 未登录重新登录
        window.location.href = res.data.url
      } else if (res.stat == 0) {
        setTimeout(() => {
          Message.error(res.msg || '请求失败')
        }, 10)
      }
      return res
    },
    error => {
      // Do something with response error
      setTimeout(() => {
        Message.error('出了点问题，请稍后重试')
      }, 10)
      return Promise.reject(error)
    }
  )
}

export const _request = (url = '', options = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const axiosConfig = _merge({}, defaultConfig, {
        url,
        ...options,
        method: options.method ? options.method.toLowerCase() : 'get'
      })
    
      if(axiosConfig.method === 'get') {
        axiosConfig.params = axiosConfig.data
        delete axiosConfig.data
      }

      const res = await axios(axiosConfig)
      resolve(res)
    } catch (error) {
      reject(error)
    }
  })
}


// WEBPACK FOOTER //
// ./pc/yiqijian-video/utils/request.js